/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { UserRetrieveResponse } from '../types/UserRetrieve';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type UsersRetrieveRequest = {} | null | undefined;
export type UsersRetrieveResponse = UserRetrieveResponse;

export type UsersRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this user.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/users/{id}/
 *
 * ```yaml
 * operationId: users_retrieve
 * tags:
 *   - users
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/UserRetrieve'
 *     description: ''
 * ```
 */
export const usersRetrieveOperation = ({ id, ...rest }: UsersRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/users/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/users/{id}/' };
  };

/**
 * GET /dmx-server/users/{id}/
 *
 * ```yaml
 * operationId: users_retrieve
 * tags:
 *   - users
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/UserRetrieve'
 *     description: ''
 * ```
 */
export const usersRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: UsersRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<UserRetrieveResponse>> => {
  const operation = usersRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/users/{id}/
 */
export const useUsersRetrieveResource = (
  query: UsersRetrieveQuery | null,
  useCached?: boolean,
): UseResource<UsersRetrieveResponse> => {
  return useResource<UsersRetrieveResponse>({
    path: query === null ? null : usersRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
